import {
  Box,
  Flex,
  HStack,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs
} from '@chakra-ui/react';
import { NextPage } from 'next';
import React, { useState } from 'react';

import { PageTitle } from '@app/components/PageTitle';
import { PositionsList } from '@app/screens/positions/components/PositionsList';
import { SpNftsList } from '@app/screens/positions/components/SpNftsList';
import s from '@app/pages/pools/v2/[id]/PairDetailsPage.module.scss';
import { VerifiedPositionsList } from '@app/screens/positions/components/PositionsList/VerifiedPositionsList';
import { VerifiedPositionsListV3 } from '@app/screens/positions/components/PositionsList/VerifiedPositionsListV3';
import { MarketMakerWidget } from '@app/screens/positions/components/MarketMakerWidget';
import { CreatePositionButton } from '@app/screens/positions/components/CreatePositionButton';
import { VaultsPositionsList } from '@app/screens/positions/components/PositionsList/VaultsPositionsList';
import { useConfig } from '@app/config';
import Metadata from '@app/components/Metadata';
import AnimatedLayout from '@app/layouts/AnimatedLayout/AnimatedLayout';

export const PositionsPage: NextPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const config = useConfig();

  const handleTabsChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <AnimatedLayout>
      <Metadata title={'Positions | Kim'} />
      <Box width="100%" mt={8} px={[0, 7]}>
        <Flex
          justify="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={6}
        >
          <PageTitle
            title="My Positions"
            subtitle="Create and manage all your staking positions."
          />
          <CreatePositionButton />
        </Flex>
        <Box mt={8}>
          <HStack mb={6} flexWrap="wrap">
            <MarketMakerWidget />
          </HStack>
          <Tabs index={tabIndex} onChange={handleTabsChange}>
            <TabList className={s.tabs}>
              {config?.FLAGS.showSpNft && <Tab className={s.tab}>kpNFTs</Tab>}
              <Tab className={s.tab}>LP V4</Tab>
              {config?.FLAGS.showVaults && (
                <Tab className={s.tab}>Vaults V4</Tab>
              )}
              <Tab className={s.tab}>LP V2</Tab>
            </TabList>
            <TabIndicator
              mt="-3px"
              height="3px"
              bg="orange"
              borderRadius="1px"
            />
            <TabPanels className={s.tabsPanels}>
              {config?.FLAGS.showSpNft && (
                <TabPanel>
                  <SpNftsList />
                </TabPanel>
              )}
              <TabPanel>
                {tabIndex === 1 && <VerifiedPositionsListV3 />}
              </TabPanel>
              {config?.FLAGS.showVaults && (
                <TabPanel>{tabIndex === 2 && <VaultsPositionsList />}</TabPanel>
              )}
              <TabPanel>
                {tabIndex === 3 && (
                  <>
                    <VerifiedPositionsList />
                    <PositionsList />
                  </>
                )}
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>
    </AnimatedLayout>
  );
};

export default PositionsPage;
